import React, { useState } from 'react'
import { Input, Select, Checkbox, CompanyPicker, formatSelectOptions } from '../../../../components'
import { eventGuestService } from '../../services'

const RESPONSE_OPTIONS = [{ value: 'yes', label: 'Ja' }, { value: 'no', label: 'Nej' }]

// Full single-guest edit dialog — the counterpart GuestAddForm's inline
// add-row doesn't have: every guest field (name/company/email/response) plus
// this event's custom fields, all editable in one place instead of one
// field at a time via the bulk-edit dialog. Same dialogRef/hideModalDialog/
// setLoadingModalDialog/onSaved contract as EventEditForm.
export const GuestEditForm = ({ guest, fieldDefs, dialogRef, hideModalDialog, setLoadingModalDialog, onSaved }) => {
  const [name, setName] = useState(guest.event_guest_name || '')
  const [companyUuid, setCompanyUuid] = useState(guest.event_guest_company_uuid || '')
  const [companyName, setCompanyName] = useState(guest.event_guest_company_name || '')
  const [email, setEmail] = useState(guest.event_guest_email || '')
  const [response, setResponse] = useState(guest.event_guest_response || '')
  const [customData, setCustomData] = useState(guest.event_guest_custom_data || {})
  const [error, setError] = useState(null)

  const setCustomValue = (key, value) => setCustomData(prev => ({ ...prev, [key]: value }))

  const submit = () => {
    setError(null)

    if (!name.trim()) {
      setError('Namn krävs')
      return Promise.resolve()
    }

    setLoadingModalDialog(true)
    return eventGuestService.update(guest.event_guest_uuid, {
      event_guest_name: name.trim(),
      event_guest_company_uuid: companyUuid || null,
      event_guest_company_name: companyName || null,
      event_guest_email: email.trim() || null,
      event_guest_response: response || null,
      event_guest_custom_data: customData,
    })
      .then(res => {
        setLoadingModalDialog(false)
        hideModalDialog()
        onSaved && onSaved(res.guest)
      })
      .catch(err => {
        setLoadingModalDialog(false)
        setError(err.message || 'Kunde inte spara gäst')
      })
  }

  if (dialogRef) dialogRef.current = { submit }

  return (
    <div className="form">
      {error && <div className="form-error">{error}</div>}

      <div className="form-block vertical">
        <Input type="text" name="event_guest_name" label="Namn" value={name} onChange={e => setName(e.target.value)} />
      </div>

      <div className="ev-row">
        <div className="form-block vertical">
          <CompanyPicker
            name="company_uuid"
            label="Företag"
            value={companyUuid}
            onChange={({ value, company }) => { setCompanyUuid(value); setCompanyName(company?.company_name || '') }}
            allowCreate
            isNullable
          />
        </div>
        <div className="form-block vertical">
          <Input type="text" name="event_guest_email" label="E-post" value={email} onChange={e => setEmail(e.target.value)} />
        </div>
      </div>

      <div className="form-block vertical">
        <label>Svar</label>
        <Select
          name="event_guest_response"
          value={response}
          options={formatSelectOptions({ options: RESPONSE_OPTIONS, optionValue: 'value', optionLabel: 'label' })}
          onChange={({ value }) => setResponse(value || '')}
          isNullable
          placeholder="Inget svar än"
        />
      </div>

      {fieldDefs.length > 0 &&
        <div className="ev-row">
          {fieldDefs.map(fd => (
            <div className="form-block vertical" key={fd.event_field_def_id}>
              {fd.field_type === 'boolean'
                ? <Checkbox
                    name={fd.field_key}
                    checked={!!customData[fd.field_key]}
                    onChange={() => setCustomValue(fd.field_key, !customData[fd.field_key])}
                    label={fd.field_label}
                  />
                : (
                  <>
                    <label>{fd.field_label}</label>
                    <Input
                      type={fd.field_type === 'number' ? 'number' : 'text'}
                      value={customData[fd.field_key] ?? ''}
                      onChange={e => setCustomValue(fd.field_key, e.target.value)}
                    />
                  </>
                )
              }
            </div>
          ))}
        </div>
      }
    </div>
  )
}
